import { createUseStyles } from 'react-jss'

const styleOverride = createUseStyles({
  root: {
    strokeWidth: '1.2',
    fill: '#464646',
  },
})

export default styleOverride
